<script setup lang="ts">
import TransportsWrapper from '@/components/transports/TransportsWrapper.vue';
import { RoleGroups } from '@/constants/Roles';
import { TransportType } from '@/constants/TransportType';

definePage({
  name: 'TransportsExport',
  meta: {
    title: 'pageTitles.exportTransports',
    roles: RoleGroups.Transports
  }
});
</script>

<template>
  <TransportsWrapper :transport-type="TransportType.Export" />
</template>

<style scoped>

</style>